import { createAction } from '@reduxjs/toolkit'

export const fetchAllLogs = createAction('views/adminLogs/fetchAllLogs')
